import React from 'react';

import cx from 'classnames';
import s from './SecondaryMenu.css';

const SecondaryMenuListItem = ({ className, children, id, active, handleClick }) => {
  const isActive = active ? s.active : '';

  return (
    <div id={id} className={cx(s.menuItem, className, isActive)} onClick={handleClick}>
      {children}
      <i className={cx(s.arrow)} />
    </div>
  );
};

export default SecondaryMenuListItem;



// WEBPACK FOOTER //
// ./src/components/SecondaryMenu/SecondaryMenuItem.js